import { useLocation } from 'react-router-dom'
import { format } from 'date-fns'
import { id } from 'date-fns/locale'

const PAGE_TITLES = {
  '/': '📊 Dashboard',
  '/projects': '🏗️ Proyek',
  '/reports': '📋 Laporan Harian',
  '/rab': '💰 RAB & AHS',
  '/materials': '📦 Material',
  '/workers': '👷 Tenaga Kerja',
  '/invoices': '💳 Invoice',
  '/documents': '📸 Dokumen',
}

export default function Topbar({ setSbOpen }) {
  const location = useLocation()
  const today = format(new Date(), 'EEEE, dd MMMM yyyy', { locale: id })
  const title = PAGE_TITLES[location.pathname] || 'Undagi'

  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <button className="menu-btn" onClick={() => setSbOpen(true)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <h2 style={{ fontSize: 15, fontWeight: 700 }}>{title}</h2>
      </div>
      <div className="topbar-date">{today}</div>
    </div>
  )
}